var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import SvgIcon from "~/components/common/svg-icon.vue";
import CommonTitle from "~/components/common/common-title.vue";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
import { VisitCaseManageService } from "~/services/domain-service/visit-case-manage.service";
import { LegalCaseManageService } from "~/services/domain-service/legal-case-manage.service";
var CollectionExecutionModule = namespace("collection-execution");
import { MENU_CHANNEL } from "~/config/enum.config.ts";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
var PendingCollectionQuery = /** @class */ (function (_super) {
    __extends(PendingCollectionQuery, _super);
    function PendingCollectionQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            personalName: "",
            followupBack: ""
        };
        _this.dataSource = [];
        _this.rowIndex = -1;
        _this.loading = { state: false };
        _this.hidden = true;
        _this.hover = false;
        return _this;
    }
    PendingCollectionQuery.prototype.created = function () {
        this.page.layout = "total, prev, next";
        this.page.update({
            totalElements: this.otherData.page.total,
            totalPages: this.otherData.page.totalPage
        });
        this.page.pageIndex = this.otherData.page.pageIndex;
    };
    PendingCollectionQuery.prototype.mounted = function () {
        this.refreshData();
    };
    PendingCollectionQuery.prototype.refreshData = function () {
        var queryData = __assign(__assign({}, this.otherData.data), this.model);
        this.loading.state = true;
        switch (this.menuChannel) {
            case MENU_CHANNEL.Tel_team:
                this.telCaseService
                    .teamCasePool(queryData, this.page, this.sort)
                    .subscribe(this.onDataRefreshComplete);
                break;
            case MENU_CHANNEL.Tel_personal:
                this.telCaseService
                    .teamCasePool(queryData, this.page, this.sort)
                    .subscribe(this.onDataRefreshComplete);
                break;
            case MENU_CHANNEL.Visit_personal:
                this.visitCaseManageService
                    .visitPersonalCasePool(queryData, this.page, this.sort)
                    .subscribe(this.onDataRefreshComplete);
                break;
            case MENU_CHANNEL.Visit_team:
                this.visitCaseManageService
                    .visitTeamCasePool(queryData, this.page, this.sort)
                    .subscribe(this.onDataRefreshComplete);
            case MENU_CHANNEL.Legal_personal:
                this.legalCaseManageService
                    .personalCasePool(queryData, this.page, this.sort)
                    .subscribe(this.onDataRefreshComplete);
                break;
            case MENU_CHANNEL.Legal_team:
                this.legalCaseManageService
                    .teamCasePool(queryData, this.page, this.sort)
                    .subscribe(this.onDataRefreshComplete);
                break;
        }
    };
    PendingCollectionQuery.prototype.onDataRefreshComplete = function (data) {
        this.dataSource = data;
        this.loading.state = false;
    };
    PendingCollectionQuery.prototype.onRowClick = function (row, event, column) {
        this.updateCaseId(row.id);
    };
    PendingCollectionQuery.prototype.cellStyle = function (_a) {
        var row = _a.row, columnIndex = _a.columnIndex;
        if (row.id === this.caseId) {
            return { color: "#FF9666" };
        }
        if (columnIndex === 0) {
            return { cursor: "pointer" };
        }
    };
    __decorate([
        Dependencies(VisitCaseManageService)
    ], PendingCollectionQuery.prototype, "visitCaseManageService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], PendingCollectionQuery.prototype, "telCaseService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], PendingCollectionQuery.prototype, "legalCaseManageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], PendingCollectionQuery.prototype, "sort", void 0);
    __decorate([
        Dependencies(PageService)
    ], PendingCollectionQuery.prototype, "page", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], PendingCollectionQuery.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], PendingCollectionQuery.prototype, "otherData", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], PendingCollectionQuery.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], PendingCollectionQuery.prototype, "updateCaseId", void 0);
    PendingCollectionQuery = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                SvgIcon: SvgIcon,
                CommonTitle: CommonTitle
            }
        })
    ], PendingCollectionQuery);
    return PendingCollectionQuery;
}(Vue));
export default PendingCollectionQuery;
